import { ref, onMounted, onUnmounted } from "vue";

export function useTheme() {
  const theme = ref(localStorage.getItem("theme") || "light");

  const setTheme = (newTheme) => {
    theme.value = newTheme;
    document.documentElement.setAttribute("data-theme", newTheme);
    localStorage.setItem("theme", newTheme);
  };

  const handleStorageChange = (e) => {
    if (e.key === "theme") {
      theme.value = e.newValue;
      document.documentElement.setAttribute("data-theme", e.newValue);
    }
  };

  onMounted(() => {
    // Initialize theme from DOM or localStorage
    const current = document.documentElement.getAttribute("data-theme");
    if (current && current !== theme.value) theme.value = current;

    // Listen to storage changes across tabs/windows
    window.addEventListener("storage", handleStorageChange);

    // Optional: observe DOM changes (for when theme changes via button/script)
    const observer = new MutationObserver(() => {
      const domTheme = document.documentElement.getAttribute("data-theme");
      if (domTheme && domTheme !== theme.value) theme.value = domTheme;
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });

    onUnmounted(() => observer.disconnect());
  });

  onUnmounted(() => {
    window.removeEventListener("storage", handleStorageChange);
  });

  return { theme, setTheme };
}
